import React, { Component, createRef, useState, useEffect } from "react";
import { Row, Col, Card, Button, Space, Typography, Table, Input, Modal, Checkbox, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faSearch } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import _ from "lodash";

const NEW_BILLING_STATUS_BASE_STATE = { name: "", billable: 0, billing_status_categories_object: null, billing_status_categories_xref: null };

function BillingStatuses(props) {
  const [billingStatuses, setBillingStatuses] = useState([]);
  const [filteredBillingStatuses, setFilteredBillingStatuses] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);

  const [selectedBillingStatus, setSelectedBillingStatus] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [newBillingStatus, setNewBillingStatus] = useState(NEW_BILLING_STATUS_BASE_STATE);

  const [billingStatusCategories, setBillingStatusCategories] = useState([]);

  const table_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <Typography.Title level={5}>{text}</Typography.Title>,
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
      defaultSortOrder: "ascend",
    },
    {
      title: "Billing Status Category",
      dataIndex: "billing_status_category_name",
      key: "billing_status_category_name",
      sorter: (a, b) => (a.billing_status_category_name.toUpperCase() > b.billing_status_category_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Billable Time",
      dataIndex: "billable",
      key: "billable",
      render: (text) => <Checkbox checked={text} disabled />,
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (text, row) => (
        <Space>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              let billing_status = billingStatuses.find((f) => f.id === text);
              setSelectedBillingStatus({ ...billing_status, billing_status_categories_object: billingStatusCategories.find((f) => f.id === billing_status.billing_status_category_xref) });
              setEditModalOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="mr-1" />
            Edit
          </Button>
          <Button
            size="small"
            danger
            onClick={() => {
              setDeleteModalOpen(true);
              setSelectedBillingStatus(billingStatuses.find((f) => f.id === text));
            }}
          >
            <FontAwesomeIcon icon={faTrash} className="mr-1" />
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const GetBillingStatuses = async () => {
    let response = await props.AxiosRequest("/api/billing-statuses/get");
    setBillingStatuses(response.data.billing_statuses);
    setFilteredBillingStatuses(response.data.billing_statuses);
  };
  const UpdateBillingStatus = async () => {
    if (selectedBillingStatus.name.length === 0 || !selectedBillingStatus.billing_status_category_xref) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/billing-statuses/update", { ...selectedBillingStatus });
    GetBillingStatuses();
    setEditModalOpen(false);
    setSelectedBillingStatus(null);
  };
  const DeleteBillingStatus = async () => {
    await props.AxiosRequest("/api/billing-statuses/delete", { id: selectedBillingStatus.id });
    GetBillingStatuses();
    setDeleteModalOpen(false);
    setSelectedBillingStatus(null);
  };
  const AddBillingStatus = async () => {
    if (newBillingStatus.name.length === 0 || !newBillingStatus.billing_status_categories_xref) return props.MakeNotification("info", "Please Enter All Required Fields.");
    await props.AxiosRequest("/api/billing-statuses/insert", { ...newBillingStatus });
    GetBillingStatuses();
    setAddModalOpen(false);
    setNewBillingStatus(NEW_BILLING_STATUS_BASE_STATE);
  };

  const GetBillingStatusCategories = async () => {
    let response = await props.AxiosRequest("/api/billing-status-categories/get");
    setBillingStatusCategories(
      response.data.billing_status_categories.map((m) => {
        return { ...m, label: m.name, value: m.id };
      }),
    );
  };

  useEffect(() => {
    GetBillingStatuses();
    GetBillingStatusCategories();
  }, []);

  useEffect(() => {
    if (searchTerm?.length === 0) return setFilteredBillingStatuses(billingStatuses);
    let filtered_list = billingStatuses.filter((f) => (_.toLower(f.name).indexOf(_.toLower(searchTerm)) > -1 ? true : false));
    setFilteredBillingStatuses(filtered_list);
  }, [searchTerm]);

  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Billing Statuses</h1>
        </div>
        <Row>
          <Card
            title={<>Billing Statuses</>}
            style={{
              width: "100%",
            }}
            extra={
              <>
                <Button
                  type="primary"
                  onClick={() => {
                    setNewBillingStatus(NEW_BILLING_STATUS_BASE_STATE);
                    setAddModalOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  Add A New Billing Status
                </Button>
              </>
            }
          >
            <Row>
              <Col span={18}></Col>
              <Col span={6}>
                <Input
                  className="mb-2"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  placeholder="Search..."
                  allowClear
                />
              </Col>
            </Row>
            <Table className="table table-striped hover" columns={table_columns} dataSource={filteredBillingStatuses} />
          </Card>
        </Row>
        <Modal
          title={"Edit Billing Status"}
          centered
          open={editModalOpen}
          onCancel={() => {
            setEditModalOpen(false);
            setSelectedBillingStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setEditModalOpen(false);
                  setSelectedBillingStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  UpdateBillingStatus();
                }}
              >
                Save Changes
              </Button>
            </>
          }
        >
          {selectedBillingStatus ? (
            <>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col span={16}>
                  <label className="col-form-label-sm">Billing Status Name *</label>
                  <Input
                    value={selectedBillingStatus.name}
                    onChange={(e) => {
                      setSelectedBillingStatus({ ...selectedBillingStatus, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={8}>
                  <Tooltip title="This denotes time that will show up on an invoice, or has been on an invoice in the past. Typically, that means both Unbilled and Billed time.">
                    <label className="col-form-label-sm">Is This Billable Time?</label>
                  </Tooltip>
                  <br />
                  <Checkbox
                    checked={selectedBillingStatus.billable}
                    onChange={(e) => {
                      setSelectedBillingStatus({ ...selectedBillingStatus, billable: e.target.checked ? 1 : 0 });
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <label className="col-form-label-sm">Billing Status Category *</label>
                  <Select
                    value={selectedBillingStatus.billing_status_categories_object}
                    options={billingStatusCategories}
                    onChange={(e) => {
                      setSelectedBillingStatus({ ...selectedBillingStatus, billing_status_categories_xref: e.value, billing_status_categories_object: e });
                    }}
                  />
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>

        <Modal
          title="Are you sure?"
          centered
          open={deleteModalOpen}
          onCancel={() => {
            setDeleteModalOpen(false);
            setSelectedBillingStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setDeleteModalOpen(false);
                  setSelectedBillingStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => {
                  DeleteBillingStatus();
                }}
              >
                Delete
              </Button>
            </>
          }
        >
          {selectedBillingStatus ? <>Are you sure you want to delete the billing status {selectedBillingStatus?.name}?</> : null}
        </Modal>

        <Modal
          title={"Add A New Billing Status"}
          centered
          open={addModalOpen}
          onCancel={() => {
            setAddModalOpen(false);
            setSelectedBillingStatus(null);
          }}
          footer={
            <>
              <Button
                onClick={() => {
                  setAddModalOpen(false);
                  setSelectedBillingStatus(null);
                }}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  AddBillingStatus();
                }}
              >
                Add
              </Button>
            </>
          }
        >
          {newBillingStatus ? (
            <>
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                <Col span={16}>
                  <label className="col-form-label-sm">Billing Status Name *</label>
                  <Input
                    value={newBillingStatus.name}
                    onChange={(e) => {
                      setNewBillingStatus({ ...newBillingStatus, name: e.target.value });
                    }}
                  />
                </Col>
                <Col span={8}>
                  <Tooltip title="This denotes time that will show up on an invoice, or has been on an invoice in the past. Typically, that means both Unbilled and Billed time.">
                    <label className="col-form-label-sm">Is This Billable Time?</label>
                  </Tooltip>
                  <br />
                  <Checkbox
                    value={newBillingStatus.billable}
                    onChange={(e) => {
                      setNewBillingStatus({ ...newBillingStatus, billable: e.target.checked ? 1 : 0 });
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <label className="col-form-label-sm">Billing Status Category *</label>
                  <Select
                    value={newBillingStatus.billing_status_categories_object}
                    options={billingStatusCategories}
                    onChange={(e) => {
                      setNewBillingStatus({ ...newBillingStatus, billing_status_categories_xref: e.value, billing_status_categories_object: e });
                    }}
                  />
                </Col>
              </Row>
            </>
          ) : null}
        </Modal>
      </div>
    </main>
  );
}

export default BillingStatuses;
